import * as React from 'react'
import { PageSection, Title } from '@patternfly/react-core'
import GenericBreadCrumb from 'src/frontend/app/components/GenericBreadCrumb'
import GenericAlert from '../components/GenericAlert'
import { PATH_TO_FO_COOKIE } from 'src/app/utils/RoutesConstants'

const title = 'Informazioni cookie'

const breadcrumbOptions = [
  { label: "Informativa cookie", link: PATH_TO_FO_COOKIE }
]

interface CookieState {
  message: string
  typeMessage: 'default' | 'success' | 'danger' | 'warning' | 'info'
}

class Cookie extends React.Component<{}, CookieState> {
  constructor(props: {}) {
    super(props)
    this.state = {
      message: '',
      typeMessage: 'default'
    }
  }

  render() {
    const { typeMessage, message } = this.state

    return (
      <div className='row'>
        <PageSection id='pageSectionId'>
          <div className='container register-container'>
            <GenericBreadCrumb paths={breadcrumbOptions} />
            <Title headingLevel="h1">{title}</Title>

            <GenericAlert hidden={message === ''} label={message} color={typeMessage} />

            <div className="mt-4">
              <section>
                <Title headingLevel="h2">Informazioni sui cookie del sito web https://www.sidafonline.it</Title>
                <p>Questo documento descrive l’utilizzo dei cookie all'interno del sito web e costituisce parte integrante della “Privacy Policy” di [inserire ragione sociale del titolare del trattamento].</p>
                <p>I cookie sono piccole porzioni di dati... migliorando così la navigazione del sito.</p>
                <p>Il nostro sito può contenere link, servizi... sui quali non possiamo avere il controllo diretto.</p>
              </section>

              <section>
                <Title headingLevel="h2">Cosa sono i cookie</Title>
                <p>I cookie sono piccoli file di testo salvati nel computer dell'utente... migliorare la navigazione.</p>
                <p>I cookie di prime parti sono impostati dal sito web stesso... mentre quelli di terze parti da altri domini.</p>
              </section>

              <section>
                <Title headingLevel="h2">Perché utilizziamo i cookie</Title>
                <p>I cookie raccolgono informazioni come IP, tipo di browser, lingua... per migliorare il servizio.</p>
                <p>Non permettono di identificare l'utente salvo dati forniti volontariamente.</p>

                <Title headingLevel="h3">Cookie del gestore del Sito</Title>
                <ul>
                  <li>
                    Cookie di sessione e tecnici usati per identificare in modo sicuro la sessione. Non raccolgono dati personali.
                  </li>
                </ul>
                <p>Elenco cookie tecnici:</p>
                <table>
                  <thead>
                    <tr>
                      <th>Cookie</th>
                      <th>Tipo</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>_utma, _utmb, _utmc, _utmz</td>
                      <td>Cookie tecnici</td>
                    </tr>
                  </tbody>
                </table>
              </section>

              <section>
                <Title headingLevel="h2">Cookie di profilazione e/o analitici</Title>
                <p>Non sono presenti cookie di profilazione o analitici utilizzati dal gestore del Sito.</p>
              </section>

              <section>
                <Title headingLevel="h2">Cookie di parti terze</Title>
                <ul>
                  <li>
                    Cookie per integrare software di terze parti: icone, social media, mappe ecc.
                    <ul>
                      <li>YouTube (Google): <a href="https://www.youtube.com/static?template=privacy_guidelines&gl=IT" target="_blank" rel="noopener noreferrer">Informativa</a></li>
                      <li>Google Maps: <a href="http://www.google.com/maps/about/behind-the-scenes/streetview/privacy/" target="_blank" rel="noopener noreferrer">Informativa</a></li>
                      <li>Social Network:
                        <ul>
                          <li>Facebook:</li>
                          <li>Twitter:</li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </section>

              <section>
                <Title headingLevel="h2">Modalità del trattamento</Title>
                <p>Il trattamento è effettuato con strumenti automatizzati. Nessuna diffusione o comunicazione.</p>
              </section>

              <section>
                <Title headingLevel="h2">Conferimento dei dati</Title>
                <p>Tranne i cookie tecnici, il conferimento è volontario. L'utente può rifiutare l’uso dei cookie modificando le impostazioni del browser.</p>
              </section>

              <section>
                <Title headingLevel="h2">Disabilitazione dei cookie</Title>
                <p>L'utente può disabilitare i cookie tramite il browser. Ecco alcuni link utili:</p>
                <ul>
                  <li>Google Chrome</li>
                  <li>Mozilla Firefox</li>
                  <li>Microsoft Internet Explorer</li>
                  <li>Apple Safari</li>
                </ul>
                <p><strong>Attenzione:</strong> disattivare tutti i cookie può compromettere la navigazione del sito.</p>
              </section>
            </div>
          </div>
        </PageSection>
      </div>
    )
  }
}

export default Cookie
